import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type {
  IMPORT_STATE,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type IntercomResponse = {
  app_id: string;
  name: string;
  access_token: string;
  workspace_id: string;
  state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  created_at: string;
  created_by: string;
};

const IntercomRedirect = () => {
  const [, setRedirect] = useCrossWindowState<IntercomResponse | null>(
    'intercom-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        const data = await services.intercom.createIntercomInfo(
          code,
          workspaceAlias,
        );

        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this intercom channel...</LoadingLayout>;
};

export default IntercomRedirect;
